(function () {
  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.nbs-slider');

    sliders.forEach((slider) => {
      const slideForward = () => {
        const cardWidth = slider.querySelector('.nbs-slider__items > *').offsetWidth;
        slider.scrollBy(Math.abs(window.innerWidth - 2 * cardWidth), 0);
      };

      const slideBackward = () => {
        const cardWidth = slider.querySelector('.nbs-slider__items > *').offsetWidth;
        slider.scrollBy(-window.innerWidth + 2 * cardWidth, 0);
      };

      slider.querySelector('.nbs-slider__prev').addEventListener('click', slideBackward);
      slider.querySelector('.nbs-slider__next').addEventListener('click', slideForward);

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.target.className.includes('start')) {
              slider.classList.toggle('nbs-slider--start', entry.isIntersecting);
            }
            if (entry.target.className.includes('end')) {
              slider.classList.toggle('nbs-slider--end', entry.isIntersecting);
            }
          });
        },
        { root: slider }
      );

      const observed = slider.querySelectorAll('.nbs-slider__start-gutter, .nbs-slider__end-gutter');
      observed.forEach(el => observer.observe(el));
    });
  });
})();
